import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/map/map.png'


const _withScopeId = n => (_pushScopeId("data-v-e84a6c30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "map" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "行きたい場所を選んでね")
], -1))
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "map",
  src: _imports_1
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p0 n1" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p0 n5" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p0 n8" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p0 n13" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p0 n15" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p0 n16" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p1 n2" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p1 n4" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p1 n7" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p1 n9" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p1 n10" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p1 n17" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p2 n3" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p2 n6" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p2 n11" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p2 n12" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p2 n14" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post p2 n18" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "1", -1))
const _hoisted_26 = { class: "sub" }
const _hoisted_27 = { class: "main" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "2", -1))
const _hoisted_29 = { class: "sub" }
const _hoisted_30 = { class: "main" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "3", -1))
const _hoisted_32 = { class: "sub" }
const _hoisted_33 = { class: "main" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "4", -1))
const _hoisted_35 = { class: "sub" }
const _hoisted_36 = { class: "main" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "5", -1))
const _hoisted_38 = { class: "sub" }
const _hoisted_39 = { class: "main" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "6", -1))
const _hoisted_41 = { class: "sub" }
const _hoisted_42 = { class: "main" }
const _hoisted_43 = { class: "flex-container" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "1", -1))
const _hoisted_45 = { class: "sub" }
const _hoisted_46 = { class: "main" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "2", -1))
const _hoisted_48 = { class: "sub" }
const _hoisted_49 = { class: "main" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "3", -1))
const _hoisted_51 = { class: "sub" }
const _hoisted_52 = { class: "main" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "4", -1))
const _hoisted_54 = { class: "sub" }
const _hoisted_55 = { class: "main" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "5", -1))
const _hoisted_57 = { class: "sub" }
const _hoisted_58 = { class: "main" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "6", -1))
const _hoisted_60 = { class: "sub" }
const _hoisted_61 = { class: "main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", null, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", {
        class: _normalizeClass(["pin current", { hover: _ctx.isInfoHover }])
      }, null, 2),
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      _hoisted_16,
      _hoisted_17,
      _hoisted_18,
      _hoisted_19,
      _hoisted_20,
      _hoisted_21,
      _hoisted_22,
      _hoisted_23,
      _hoisted_24,
      _createElementVNode("div", {
        class: _normalizeClass(["pin tech", { hover: _ctx.isTechHover }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.link(2)))
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["pin real", { hover: _ctx.isRealHover }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.link(3)))
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["pin drone", { hover: _ctx.isDroneHover }]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.link(4)))
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["pin showroom", { hover: _ctx.isShowroomHover }]),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.link(5)))
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["pin room", { hover: _ctx.isRoomHover }]),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.link(6)))
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["pin life", { hover: _ctx.isLifeHover }]),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.link(7)))
      }, null, 2),
      _createElementVNode("div", {
        class: "pavillion n1",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.link(2)))
      }, [
        _hoisted_25,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.pavillion[0].sub), 1),
          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.pavillion[0].main), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: "pavillion n2",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.link(3)))
      }, [
        _hoisted_28,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.pavillion[1].sub), 1),
          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.pavillion[1].main), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: "pavillion n3",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.link(4)))
      }, [
        _hoisted_31,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.pavillion[2].sub), 1),
          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.pavillion[2].main), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: "pavillion n4",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.link(5)))
      }, [
        _hoisted_34,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.pavillion[3].sub), 1),
          _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.pavillion[3].main), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: "pavillion n5",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.link(6)))
      }, [
        _hoisted_37,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.pavillion[4].sub), 1),
          _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.pavillion[4].main), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: "pavillion n6",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.link(7)))
      }, [
        _hoisted_40,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.pavillion[5].sub), 1),
          _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.pavillion[5].main), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          class: "pavillion",
          onMouseover: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isTechHover = true)),
          onMouseleave: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isTechHover = false)),
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.link(2)))
        }, [
          _hoisted_44,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.pavillion[0].sub), 1),
            _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.pavillion[0].main), 1)
          ])
        ], 32),
        _createElementVNode("li", {
          class: "pavillion",
          onMouseover: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isRealHover = true)),
          onMouseleave: _cache[17] || (_cache[17] = ($event: any) => (_ctx.isRealHover = false)),
          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.link(3)))
        }, [
          _hoisted_47,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.pavillion[1].sub), 1),
            _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.pavillion[1].main), 1)
          ])
        ], 32),
        _createElementVNode("li", {
          class: "pavillion",
          onMouseover: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isDroneHover = true)),
          onMouseleave: _cache[20] || (_cache[20] = ($event: any) => (_ctx.isDroneHover = false)),
          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.link(4)))
        }, [
          _hoisted_50,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.pavillion[2].sub), 1),
            _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.pavillion[2].main), 1)
          ])
        ], 32),
        _createElementVNode("li", {
          class: "pavillion",
          onMouseover: _cache[22] || (_cache[22] = ($event: any) => (_ctx.isShowroomHover = true)),
          onMouseleave: _cache[23] || (_cache[23] = ($event: any) => (_ctx.isShowroomHover = false)),
          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.link(5)))
        }, [
          _hoisted_53,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.pavillion[3].sub), 1),
            _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.pavillion[3].main), 1)
          ])
        ], 32),
        _createElementVNode("li", {
          class: "pavillion",
          onMouseover: _cache[25] || (_cache[25] = ($event: any) => (_ctx.isRoomHover = true)),
          onMouseleave: _cache[26] || (_cache[26] = ($event: any) => (_ctx.isRoomHover = false)),
          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.link(6)))
        }, [
          _hoisted_56,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.pavillion[4].sub), 1),
            _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.pavillion[4].main), 1)
          ])
        ], 32),
        _createElementVNode("li", {
          class: "pavillion",
          onMouseover: _cache[28] || (_cache[28] = ($event: any) => (_ctx.isLifeHover = true)),
          onMouseleave: _cache[29] || (_cache[29] = ($event: any) => (_ctx.isLifeHover = false)),
          onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.link(7)))
        }, [
          _hoisted_59,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.pavillion[5].sub), 1),
            _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.pavillion[5].main), 1)
          ])
        ], 32)
      ])
    ])
  ], 512))
}